import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) =>
  createStyles({
    formControl: {
      display: "flex",
    },
    dropdownStyle: {
      borderRadius: 24,
      backgroundColor: theme.palette.type === "dark" ? "#3c497d" : "#f7f8fd",
      border: "1px solid #f0f3f6",
    },
    list: {
      padding: 0,
      "& li": {
        padding: theme.spacing(2),
        borderBottom: "1px solid #EAEDF0",
        "&:last-child": {
          borderBottom: "none",
        },
      },
      "& li.Mui-selected": {
        backgroundColor: "#3289ef",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "rgb(35, 95, 167)",
        },
      },
    },
    select: {
      borderRadius: 24,
      backgroundColor: theme.palette.type === "dark" ? "#3c497d" : "#f7f8fd",
      "& .MuiSelect-select:focus": {
        borderRadius: 24,
        backgroundColor: theme.palette.type === "dark" ? "#3c497d" : "#f7f8fd",
      },
    },
    helperText: {
      margin: "0px 0px 8px 0px",
    },
  })
);

const CustomSelect = ({ text, children, ...props }) => {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl} variant="outlined">
      <FormHelperText className={classes.helperText}>{text}</FormHelperText>
      <Select
        displayEmpty
        autoWidth
        className={classes.select}
        MenuProps={{
          classes: { paper: classes.dropdownStyle, list: classes.list },
        }}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
